import React, {useState} from 'react';
import {Tooltip} from "@mui/material";
import copySVG from "../../assets/img/copyIcon.svg";
import {useSelector} from "react-redux";
import styles from "./Decloration.module.css";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";

function DeclarationSuccess(props) {
    const [isCopyed, setIsCopyed] = useState(false)
    const id = useSelector(state => state.declarationSlice.declarationNumber)
    const navigate = useNavigate()
    const copy = () => {
        navigator.clipboard.writeText(id)
            .then(() => setIsCopyed(true))

    }
    return (
        <div className='content-wrapper'>
            <h1 className='apply_title'>
                Успешно!
            </h1>
            <div className='success_container'>
                <span className='success_first-par'>Ваше заявление успешно отправлено.</span>
                <div className='condition_second-body'>
                    <span className='user_number'>Номер заявления</span>
                    <div className='condition_second-body' style={{display: "flex", alignItems: "center"}}>
                        <button className='copy_button'>
                            {id}
                        </button>
                        <Tooltip title={isCopyed ? 'Скопировано!' : ''}>
                            <img onClick={copy} src={copySVG} alt=""/>
                        </Tooltip>
                    </div>
                </div>
            </div>
            <div className={styles.goToDeclarations}>
                <Button onClick={() => navigate('/declaration')} className={styles.button + ' ' + styles.orange}  style={{width: 300, height: 65}} >Мои заявления</Button>
            </div>
        </div>
    );
}

export default DeclarationSuccess;